export default "__VITE_ASSET__DaBm4zHc__"